import { ca } from '@cian/analytics';

export const trackFeedbackTagClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BuildingProgress_JK',
    pageType: 'BuildingProgressJK',
    action: 'link_click',
    label: 'reviews',
  });
};
